module.exports = __webpack_public_path__ + "img/91825.4c7f3381.svg";